import * as Yup from "yup";

const schema = Yup.object({
  leaveTypeId: Yup.number()
    .required("Leave type is required")
    .positive("Leave type is required"),
  fromDate: Yup.string().required("From date is required"),
  toDate: Yup.string().required("To date is required"),
  isHalfDay: Yup.boolean().optional(),
  reason: Yup.string()
    .required("Reason is required")
    .min(1, "Reason is required"),
  userId: Yup.number().required("The user id is required"),
}).test("date-range", "To date must be on or after from date", (vals) => {
  if (!vals?.fromDate || !vals?.toDate) return true;
  return String(vals.toDate) >= String(vals.fromDate);
}).test("date-range-max", "Date range cannot exceed 6 months", (vals) => {
  if (!vals?.fromDate || !vals?.toDate) return true;
  const from = new Date(`${vals.fromDate}T12:00:00`);
  const to = new Date(`${vals.toDate}T12:00:00`);
  const sixMonthsLater = new Date(from);
  sixMonthsLater.setMonth(sixMonthsLater.getMonth() + 6);
  return to <= sixMonthsLater;
});

export default schema;
